import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, inject, Injector, ElementRef, Directive, Input, HostListener } from '@angular/core';
import { DOT_WIDTH_LENGTH, DOT_WIDTH_ALIASES, DOT_WIDTH_MAP } from '@css-dot/core';
import { ClassSwitch } from '@js-dot/ui';
import { Styles, StyleFactory } from '@js-dot/ui/style';
class DotCutStyleService extends Styles {
  cut = new StyleFactory(amount => {
    return {
      ['.dot-cut' + amount]: {
        display: 'grid',
        gridTemplateColumns: `repeat(${amount}, 1fr)`
      }
    };
  });
  gap = new StyleFactory(amount => {
    return {
      ['._gap' + amount]: {
        gap: amount == +amount ? amount + 'px' : amount
      }
    };
  });
  constructor(document) {
    super(document.head);
  }
  static ɵfac = function DotCutStyleService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotCutStyleService)(i0.ɵɵinject(DOCUMENT));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotCutStyleService,
    factory: DotCutStyleService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotCutStyleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();
class DotCutDirective {
  set fromSelector(amount) {
    if (amount !== undefined) {
      this.cut = amount;
      if (this._cutInit) {
        this._cutUpdateClass();
      }
    }
  }
  cut;
  gap;
  cutAt42;
  cutAt48;
  cutAt54;
  cutAt64;
  cutAt76;
  cutAt10;
  cutAt12;
  cutAt14;
  cutAt16;
  cutAt18;
  cutAt20;
  cutAt22;
  cutAt24;
  cutEnable = true;
  _host;
  _cut;
  _gap;
  _document;
  _cutInit;
  _responsible;
  _styles;
  constructor() {
    const injector = inject(Injector);
    this._document = injector.get(DOCUMENT);
    this._host = injector.get(ElementRef).nativeElement;
    this._styles = injector.get(DotCutStyleService);
  }
  ngOnChanges(changes) {
    for (let key in changes) {
      if (!changes.hasOwnProperty(key)) {
        continue;
      }
      const change = changes[key];
      this[key] = change.currentValue;
      if (key.startsWith('cutAt')) {
        this._responsible = true;
      }
      this._cutUpdateClass();
    }
  }
  ngAfterViewInit() {
    // const {_host} = this;
    //
    // const cutTarget =
    // 		  _host['.cutChild'] || _host.classList.contains('_cut_for_child') ?
    // 			  _host.getElementsByClassName('_dot-target')[0] as HTMLElement || _host :
    // 			  _host;
    //
    // this._cut = new ClassSwitch(cutTarget);
    // this._gap = new ClassSwitch(cutTarget);
    //
    // this._cutInit = true;
    // this._cutUpdateClass();
  }
  ngAfterContentInit() {
    const {
      _host
    } = this;
    const cutTarget = _host['.cutChild'] || _host.classList.contains('_cut_for_child') ? _host.getElementsByClassName('_dot-target')[0] || _host : _host;
    this._cut = new ClassSwitch(cutTarget);
    this._gap = new ClassSwitch(cutTarget);
    this._cutInit = true;
    this._cutUpdateClass();
  }
  _onWindowResize() {
    this._cutUpdateClass();
  }
  _cutUpdateClass() {
    if (!this._cutInit) {
      return;
    }
    const {
      _cut
    } = this;
    if (!this.cutEnable) {
      _cut.pop();
      return;
    }
    let cut = this.cut;
    if (this._responsible) {
      const width = this._document.body.clientWidth;
      let end = DOT_WIDTH_LENGTH;
      let current = 0; // starts with over 32
      while (++current < end) {
        const widthAlias = DOT_WIDTH_ALIASES[current];
        const mediaCut = this['cutAt' + widthAlias];
        if (mediaCut === undefined) {
          continue;
        }
        const mediaWidth = DOT_WIDTH_MAP[widthAlias];
        if (width < mediaWidth) {
          break;
        }
        cut = mediaCut;
      }
    }
    this._styles.cut.update(cut);
    _cut.set('dot-cut' + cut);
    const {
      _gap,
      gap
    } = this;
    if (gap) {
      this._styles.gap.update(gap);
      _gap.set('_gap' + gap);
    } else {
      _gap.pop();
    }
  }
  static ɵfac = function DotCutDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotCutDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotCutDirective,
    selectors: [["", "dotCut", ""]],
    hostBindings: function DotCutDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("resize", function DotCutDirective_resize_HostBindingHandler() {
          return ctx._onWindowResize();
        }, false, i0.ɵɵresolveWindow);
      }
    },
    inputs: {
      fromSelector: [0, "dotCut", "fromSelector"],
      cut: "cut",
      gap: "gap",
      cutAt42: "cutAt42",
      cutAt48: "cutAt48",
      cutAt54: "cutAt54",
      cutAt64: "cutAt64",
      cutAt76: "cutAt76",
      cutAt10: "cutAt10",
      cutAt12: "cutAt12",
      cutAt14: "cutAt14",
      cutAt16: "cutAt16",
      cutAt18: "cutAt18",
      cutAt20: "cutAt20",
      cutAt22: "cutAt22",
      cutAt24: "cutAt24",
      cutEnable: "cutEnable"
    },
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotCutDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotCut]'
    }]
  }], () => [], {
    fromSelector: [{
      type: Input,
      args: ['dotCut']
    }],
    cut: [{
      type: Input
    }],
    gap: [{
      type: Input
    }],
    cutAt42: [{
      type: Input
    }],
    cutAt48: [{
      type: Input
    }],
    cutAt54: [{
      type: Input
    }],
    cutAt64: [{
      type: Input
    }],
    cutAt76: [{
      type: Input
    }],
    cutAt10: [{
      type: Input
    }],
    cutAt12: [{
      type: Input
    }],
    cutAt14: [{
      type: Input
    }],
    cutAt16: [{
      type: Input
    }],
    cutAt18: [{
      type: Input
    }],
    cutAt20: [{
      type: Input
    }],
    cutAt22: [{
      type: Input
    }],
    cutAt24: [{
      type: Input
    }],
    cutEnable: [{
      type: Input
    }],
    _onWindowResize: [{
      type: HostListener,
      args: ['window:resize']
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotCutDirective, DotCutStyleService };
